import CRUDService from "./base/CRUDService";

export default class GatewayService extends CRUDService {

  getBaseURL() {
    return 'cloud/v1/gateways/';
  }

}



// WEBPACK FOOTER //
// ./src/services/GateServiceService.js